import React from 'react';

import { observer } from 'mobx-react';
import { LoadingIndicator } from 'stream-chat-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { LbChat } from './LbChat/LbChat';
import { chatStore } from '../../../shared/stores/chatStore';
import classes from './NgzChatPage.module.scss';

const NgzChatPage = observer(() => {
  if (!chatStore.chatClient) {
    return <LoadingIndicator />;
  }

  return (
    <div className={classes.page}>
      <LbChat />
    </div>
  );
});

angularizeWithProviders(NgzChatPage, 'ngzChatPage', {});

export { NgzChatPage };
